export default {
    mock: {
        // 本地 mock 数据
        API: '',
        CsharpApi: '',
        chatApi: '',
        // 可以访问到前端页面的URI路径
        frontResourcePath: '',
        ws: '',
        appid: '',
        cos: {
            // 图片上传cos
            domain: '',
            Bucket: '' /* 填入您自己的存储桶，必须字段 */,
            Region: '' /* 存储桶所在地域，例如ap-beijing，必须字段 */,
        },
        qrCode: '',
    },
    development: {
        // 开发环境接口请求
        API: 'https://agriculture.dian.org.cn/test',
        chatApi: 'https://agriculture.dian.org.cn/chat',
        ws: 'wss://helpertest.dian.org.cn/ws', // websocket连接
        frontResourcePath: 'http://127.0.0.1', // 回调地址
        appid: 'wxfafc2322a97c75af',
        cos: {
            // 图片上传cos
            domain: 'https://cdn.helpertest.dian.org.cn/',
            Bucket: 'bucket-helpertest-1315498476' /* 填入您自己的存储桶，必须字段 */,
            Region: 'ap-guangzhou' /* 存储桶所在地域，例如ap-beijing，必须字段 */,
        },
        qrCode: 'http://mmbiz.qpic.cn/mmbiz_jpg/25BVcKvMj3F8s9kjyO4VEVkMB2XVzFIcDqsHQjPj3xD4xqVM3aem17pvzJ9u60PS8g1QcA9y9SY1bjicnAmj9Xg/0',
    },
    test: {
        // 测试环境接口地址
        API: 'https://agriculture.dian.org.cn/test',
        chatApi: 'https://agriculture.dian.org.cn/chat',
        ws: 'wss://helpertest.dian.org.cn/ws',
        frontResourcePath: 'https://agriculture.dian.org.cn',
        appid: 'wxfafc2322a97c75af',
        cos: {
            domain: 'https://cdn.helpertest.dian.org.cn/',
            Bucket: 'bucket-helpertest-1315498476',
            Region: 'ap-guangzhou',
        },
        qrCode: 'http://mmbiz.qpic.cn/mmbiz_jpg/25BVcKvMj3F8s9kjyO4VEVkMB2XVzFIcDqsHQjPj3xD4xqVM3aem17pvzJ9u60PS8g1QcA9y9SY1bjicnAmj9Xg/0',
    },
    production: {
        // 正式环境接口地址
        API: 'https://agriculture.dian.org.cn:8099/api',
        CsharpApi: 'https://agriculture.dian.org.cn:9066',
        chatApi: 'https://agriculture.dian.org.cn:9067',
        ws: 'wss://helper.dian.org.cn/ws',
        frontResourcePath: 'https://helper.dian.org.cn',
        appid: 'wxfafc2322a97c75af',
        cos: {
            domain: 'https://cdn.helper.dian.org.cn/',
            Bucket: 'helper-1301626144',
            Region: 'ap-guangzhou',
        },
        qrCode: 'https://cdn.helper.dian.org.cn/material/prod_qrcode.jpg',
    },
};
